import { PlaceApiPlaceDeleteRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const usePlaceDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: PlaceApiPlaceDeleteRequest, config) =>
      appApiClient.placeApi.placeDelete(req, config),
  });
